import { render } from "./ConsultaList.vue?vue&type=template&id=8b715354&scoped=true"
import script from "./ConsultaList.vue?vue&type=script&lang=js"
export * from "./ConsultaList.vue?vue&type=script&lang=js"

import "./ConsultaList.vue?vue&type=style&index=0&id=8b715354&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/plus.centrodeglaucoma.com/darmin-plus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b715354"]])

export default __exports__